module.exports = __webpack_public_path__ + "img/4.09513aa7.svg";